import Covenant from './Covenant';

export default Covenant;
